// extracted by mini-css-extract-plugin
export default {"container":"BT-z","topReviewHeading":"CT-z","criticalReview":"DT-z","favorableReview":"ET-z","vsSeparator":"FT-z"};